/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const SmileyHappy = ({ className, smileyHappy = "/img/smiley-happy.png" }) => {
  return <img className={`smiley-happy ${className}`} alt="Smiley happy" src={smileyHappy} />;
};

SmileyHappy.propTypes = {
  smileyHappy: PropTypes.string,
};
